// client/src/pages/pmPortal/PmPortalHome.js
// /pm-portal itself belongs to neither audience, so it just forwards to whichever tree
// the session's role owns. Having one landing URL means the office can hand out a
// single link without first working out whether the person is an owner or a resident.
import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePmPortalAuth } from '../../hooks/usePmPortalAuth';

const PmPortalHome = () => {
    const { role } = usePmPortalAuth();
    if (role === 'owner') return <Navigate to="/pm-portal/owner" replace />;
    if (role === 'tenant') return <Navigate to="/pm-portal/tenant" replace />;
    // No role in storage means the token predates it or was cleared; start over.
    return <Navigate to="/pm-portal/login" replace />;
};

export default PmPortalHome;
